module.exports = __webpack_public_path__ + "img/9_104.146cfd35.png";